import React from "react";
import locale from "@bonliva-crm/locale";
import { useGlobalStore } from "@hooks";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { sortBy } from "lodash";
import { MultiSelectFilter } from "./_common/multi-select-filter";

type Option = { label: string; value: string | null };

export type AoeFilterProps = {
  label?: string;
  options?: Option[];
} & FilterWithFavouriteProps;

export const AoeFilter = ({ label, options, ...props }: AoeFilterProps) => {
  const { cache } = useGlobalStore();
  const title = label ?? locale.AreaOfExpertise;

  const _options = options
    ? options
    : sortBy(cache.areasOfExp, "Name").map((a) => ({ label: a.Name, value: a.Name })) ??
      [];

  return <MultiSelectFilter label={title} options={_options} {...props} />;
};
